'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterDom = require('react-router-dom');

var _FontAwesome = require('./FontAwesome');

var _FontAwesome2 = _interopRequireDefault(_FontAwesome);

var _MainStore = require('../../stores/MainStore');

var _MainStore2 = _interopRequireDefault(_MainStore);

var _Utility = require('../../utils/Utility');

var Utility = _interopRequireWildcard(_Utility);

var _wlLogo = require('../../../img/wlLogo.png');

var _wlLogo2 = _interopRequireDefault(_wlLogo);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Footer = function (_React$Component) {
	_inherits(Footer, _React$Component);

	function Footer() {
		_classCallCheck(this, Footer);

		return _possibleConstructorReturn(this, (Footer.__proto__ || Object.getPrototypeOf(Footer)).apply(this, arguments));
	}

	_createClass(Footer, [{
		key: 'render',
		value: function render() {

			return _react2.default.createElement(
				'div',
				{ className: "w-100" },
				_react2.default.createElement(
					'footer',
					{ className: 'pt-4 pb-4 text-center' },
					_react2.default.createElement(
						'div',
						{ className: "container" },
						_react2.default.createElement(
							'div',
							{ id: "powered" },
							_react2.default.createElement(
								'p',
								{ className: 'text-light mt-0 mb-0 d-block font-weight-bold' },
								this.props.copyLeftText,
								new Date().getFullYear(),
								_react2.default.createElement(
									'a',
									{ className: 'd-inline-block ml-1 font-weight-bold ', target: '_blank',
										href: 'https://www.freshbytes.io',
										tabIndex: 51
									},
									this.props.firstLinkText
								),
								this.props.copyRightText
							)
						)
					)
				)
			);
		}
	}]);

	return Footer;
}(_react2.default.Component);

Footer.propTypes = {
	sectionclassName: _propTypes2.default.string,
	popularCHclassName: _propTypes2.default.string,
	popularCountries: _propTypes2.default.array,
	popularFHclassName: _propTypes2.default.string,
	popularFood: _propTypes2.default.array,
	copyRightText: _propTypes2.default.string,
	copyLeftText: _propTypes2.default.string,
	madewithIconclassName: _propTypes2.default.string,
	firstLinkText: _propTypes2.default.string,
	firstLink: _propTypes2.default.string,
	secondLinkText: _propTypes2.default.string,
	secondLink: _propTypes2.default.string
};

Footer.defaultProps = {
	sectionclassName: 'footer-bottom-search pt-5 pb-5 bg-white',
	popularCHclassName: 'text-black',
	popularCountries: [],
	popularFHclassName: 'mt-4 text-black',
	popularFood: [],
	copyLeftText: '© Copyright ',
	copyRightText: ' All rights reserved.',
	madewithIconclassName: 'heart heart-icon text-danger',
	firstLinkText: 'FreshBytes',
	firstLink: "http://freshbytes.io/",
	secondLinkText: 'Askbootstrap',
	secondLink: '//askbootstrap.com/'
};

exports.default = Footer;


//////////////////
// WEBPACK FOOTER
// ./src/components/common/Footer.jsx
// module id = 229
// module chunks = 0